import Cookies from "js-cookie";
import {
  checkLeadStatus,
  mapContactToLeadFields,
  submitPartial,
} from "./lmsApi";

// Resolve the tracker click id from whichever attribution source is active.
export const getClickId = (utm_campaign) => {
  // Permate
  utm_campaign = utm_campaign ? utm_campaign.toLowerCase() : "";
  if (utm_campaign === "pm") {
    try {
      const pmClick = JSON.parse(Cookies.get("pm_click"));
      return pmClick.click;
    } catch {
      const urlParams = new URLSearchParams(
        sessionStorage.getItem("url_params")
      );
      return (
        urlParams.get("clickid") || urlParams.get("affiliate_clickid") || ""
      );
    }
  }
  // HasOffer
  if (
    utm_campaign === "ho" ||
    utm_campaign === "direct" ||
    utm_campaign === "ndirect"
  ) {
    const offerId =
      sessionStorage.getItem("offerid") || sessionStorage.getItem("offer-id");
    const HOcidKey = `tdl_default_${offerId}`;
    if (utm_campaign === "direct") {
      return sessionStorage.getItem(HOcidKey) || "";
    }
    const params = new URLSearchParams(sessionStorage.getItem("url_params"));
    if (utm_campaign === "ndirect" && params) {
      return sessionStorage.getItem("HOclickId") || params.get("clickid") || "";
    }
    return (
      sessionStorage.getItem(HOcidKey) ||
      sessionStorage.getItem("HOclickId") ||
      (params ? params.get("clickid") : "")
    );
  }
  // Voluum
  if (utm_campaign === "vl") {
    return Cookies.get("vl-cid") || "";
  }
  return "";
};

const getPartialId = () =>
  sessionStorage.getItem("partial_id") ||
  sessionStorage.getItem("lead_id") ||
  "";

// Statuses that end the ping tree without a buyer.
export const REJECT_STATUSES = [2, 4, 5];

// The app is served under /start (see ops/deploy.sh + Router basename), so the
// fallback must carry that base path or the redirect lands on a 404.
export const getRejectUrl = () =>
  `${window.location.origin}${process.env.PUBLIC_URL || "/start"}/reject-page`;

// Normalize an InterateLeads status-check payload to the shape the
// Configuration page already consumes ({ data: { data: { status, ... } } }).
const wrapStatus = (apiJson, partialId) => {
  const status = apiJson?.status;
  const normalized = {
    ...apiJson,
    lead_id: partialId || apiJson?.lead_id,
  };
  // No buyer / rejected / error / not-found -> send the user to the reject page,
  // since the new API only returns a redirect_url for sold leads.
  if (REJECT_STATUSES.includes(status)) {
    normalized.rejectUrl = normalized.redirect_url || getRejectUrl();
  }
  return { data: { data: normalized } };
};

// Submit the lead for real: flush the full contact into the capture, then
// finalize it (promotes to a real lead and runs the ping tree).
// Kept the historical name so the Configuration page needs no import changes.
export const sendDataPhonexa = async (contactRedux) => {
  const partialId = getPartialId();
  const fields = mapContactToLeadFields(contactRedux);

  // Merge everything captured so far in case a step was skipped.
  try {
    await submitPartial(fields, partialId);
  } catch (error) {
    // Non-fatal: finalize below will still surface validation errors.
  }

  const res = await checkLeadStatus(partialId);
  return wrapStatus(res?.data, partialId);
};

// Poll the finalized lead for its sold/reject outcome.
export const checkPingResult = async (leadId, checkKey, utmSource) => {
  const partialId = checkKey || getPartialId();
  const res = await checkLeadStatus(partialId);
  return wrapStatus(res?.data, partialId);
};

// Autocomplete suggestion helpers are no longer backed by an API.
export const searchFirstNameApi = async () => [];
export const searchLastNameApi = async () => [];
export const searchJobTitleApi = async () => [];
export const searchEmployerNameApi = async () => [];
